/*
  App constants and settings
*/

import NoPhotoImage from '../assets/no-photo.jpg'
import LogoImageMosaica from '../assets/logomosaica.png'
import LogoImageHive from '../assets/hive.svg'

export const NO_PHOTO_IMAGE = NoPhotoImage
export const LOGO_IMAGE_MOSAICA = LogoImageMosaica
export const LOGO_IMAGE_HIVE = LogoImageHive